import * as modules from './modules';
import jQuery from 'jquery';

// Make NodeList.forEach() method work on inter­net explorer
(function () {
    if (typeof NodeList.prototype.forEach === "function") return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
})();

// Find all elements with a [data-module] attribute
document.querySelectorAll('[data-module]').forEach(function (el) {
    // Create array with module names
    // Multiple modules are supported by using a space separated string
    const dataModules = el.getAttribute('data-module');
    const names = dataModules && dataModules.indexOf(' ') > -1 ? dataModules.split(' ') : [dataModules];

    // Handle options attribute
    const optionsValue = el.getAttribute('data-options');
    var options = null;
    if (optionsValue && typeof optionsValue === 'string' && optionsValue.length > 2 && optionsValue.charAt(0) === '{') {
        try {
            options = JSON.parse(optionsValue);
        } catch (error) {
            throw error;
        }
    }

    // Instantiate classes
    names.forEach(function (name) {
        if (modules[name] && typeof modules[name] === 'function') {
            new modules[name](el, options);
        }
    });
});

/// Expose jQuery to window scope, to enable Coveo (and other 3rd party legacy tooling)
if (typeof (window.jQuery) === 'undefined') {
    window.jQuery = window.$ = jQuery;
}